import { ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDolly as DepositsIcon } from '@fortawesome/free-solid-svg-icons';

import ActivatedChip from '~components/ActivatedChip';

import { WarehouseDetailCardProps } from './types';
import {
  WarehouseDetailCardContainer,
  WarehouseDetailCardIconContainer,
} from './styles';

const WarehouseDetailCard = ({
  isActive,
  title,
  address,
}: WarehouseDetailCardProps): ReactElement => (
  <WarehouseDetailCardContainer>
    <WarehouseDetailCardIconContainer>
      <FontAwesomeIcon icon={DepositsIcon} />
    </WarehouseDetailCardIconContainer>

    <Stack flex={1} spacing={0.5}>
      <Stack direction="row" spacing={3} alignItems="center">
        <Typography component="h6" variant="body2" fontWeight="bold">
          {title}
        </Typography>

        <ActivatedChip
          size="small"
          type={isActive ? 'active' : 'inactive'}
          variant="filled"
        />
      </Stack>

      {address && (
        <Typography variant="caption" fontWeight={500} color="text.secondary">
          {address}
        </Typography>
      )}
    </Stack>
  </WarehouseDetailCardContainer>
);

export default WarehouseDetailCard;
